import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Box, Skeleton } from '@mui/material';
import VolumeItem from './volume-item';

function VolumesPreview() {
  const [volumes, setVolumes] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const containerRef = useRef();

  useEffect(() => {
    axios
      .get("https://api.wajls.com/client/v1/fetch_volumes.php?limit=1")
      .then((response) => {
        setVolumes(response.data);
      })
      .catch(() => {
        console.error("Failed to load volumes data.");
      });
  }, []);

  // Auto-scroll only if multiple volumes
  useEffect(() => {
    if (volumes.length <= 1) return;

    const interval = setInterval(() => {
      setIsTransitioning(true);
      setCurrentIndex((prev) => prev + 1);
    }, 5000);

    return () => clearInterval(interval);
  }, [volumes]);

  // Reset scroll if fake item is reached
  useEffect(() => {
    if (volumes.length > 1 && currentIndex === volumes.length) {
      setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(0);
      }, 800);
    }
  }, [currentIndex, volumes.length]);

  const getVisibleVolumes = () => {
    if (volumes.length <= 1) return volumes;
    return [...volumes, volumes[0]]; // Clone first to the end
  };

  const visibleVolumes = getVisibleVolumes();

  const slideStyle =
    volumes.length > 1
      ? {
          transform: `translateX(-${currentIndex * (100 / visibleVolumes.length)}%)`,
          transition: isTransitioning ? 'transform 0.8s ease-in-out' : 'none',
          display: 'flex',
          width: `${visibleVolumes.length * 100}%`,
        }
      : {};

  return (
    <Box sx={{ maxWidth: 'lg', mx: 'auto', mt: 3, p: 1, overflow: 'hidden' }}>
      {volumes.length === 0 ? (
        <Box sx={{ display: 'flex', overflow: 'hidden', gap: 2, px: 2 }}>
          {/* {[...Array(2)].map((_, i) => (
            <Box
              key={i}
              sx={{
                flex: '0 0 100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton variant="text" width="60%" height={24} />
                <Skeleton variant="rectangular" width={60} height={24} />
              </Box>
              <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 2 }} />
              <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 2 }} />
            </Box>
          ))} */}
        </Box>
      ) : (
        <>
          <Box ref={containerRef} sx={{ position: 'relative' }}>
            <Box sx={slideStyle}>
              {visibleVolumes.map((volume, idx) => (
                <Box
                  key={idx}
                  sx={{
                    flex: `0 0 ${100 / visibleVolumes.length}%`,
                    px: 1,
                    boxSizing: 'border-box',
                    transform: 'scale(0.95)',
                    transition: 'transform 0.5s',
                    ...(idx === currentIndex % volumes.length && {
                      transform: 'scale(1)',
                    }),
                  }}
                >
                  <VolumeItem
                    title={volume.title}
                    abstract_url={volume.abstract_url}
                    price={volume.price}
                    ad={true}
                  />
                </Box>
              ))}
            </Box>
          </Box>

          {/* Only show dots if multiple volumes */}
          {volumes.length > 1 && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 2,
                gap: 1,
              }}
            >
              {volumes.map((_, index) => (
                <Box
                  key={index}
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    backgroundColor:
                      index === currentIndex % volumes.length ? '#1a237e' : '#c5cae9',
                    transition: 'background-color 0.3s ease',
                  }}
                />
              ))}
            </Box>
          )}
        </>
      )}
    </Box>
  );
}

export default VolumesPreview;
